import { OrganizationConfig } from '@tenants/types/tenant';
import { EXP_CANADA_ADDRESS, EXP_QUEBEC_ADDRESS } from '@tenants/definitions/shared/addresses';
import { LOCALE_EXP_REALTY_CA_PATHS, SiteLanguage } from 'types/locales';
import { EXP_REALTY_INTERNATIONAL_LINKS } from '@tenants/definitions/exp/shared/international-links';

export function createOrganizationConfig(): OrganizationConfig {
  return {
    phoneNumber() {
      return '833-303-0610';
    },
    email() {
      return 'info@exprealty.net';
    },
    address(options) {
      // Show Quebec address if locale is fr-CA OR user is from Quebec
      if (options?.locale === SiteLanguage.FrenchCA || options?.isUserInQuebec) {
        return EXP_QUEBEC_ADDRESS;
      }
      return EXP_CANADA_ADDRESS;
    },
    twitterUrl: 'https://twitter.com/exprealtycanada',
    facebookUrl: 'https://www.facebook.com/exprealtycanada',
    instagramUrl: 'https://www.instagram.com/expcanada_?igsh=YmtqZzRqZHR1Z2Yw&utm_source=qr',
    linkedinUrl: 'https://www.linkedin.com/showcase/exprealtycanada',
    youtubeUrl: 'https://www.youtube.com/@eXpRealty',
    joinSectionUrl: 'https://join.exprealty.ca',
    internationalLinks: {
      title: LOCALE_EXP_REALTY_CA_PATHS.INTERNATIONAL_MODAL_TITLE,
      subtitle: LOCALE_EXP_REALTY_CA_PATHS.INTERNATIONAL_MODAL_SUBTITLE,
      linkData: EXP_REALTY_INTERNATIONAL_LINKS,
    },
  };
}
